import { setDoc, doc, addDoc, collection } from "firebase/firestore/lite";
import { isDesktop, isMobileOnly, isTablet } from "react-device-detect";

export async function createUserInDatabase(
  db,
  userCredential,
  formikRegisterStore
) {
  if (userCredential && userCredential.user) {
    try {
      const newUserData = {
        handle: formikRegisterStore.values.handle,
        createdAt: new Date().toISOString(),
        userId: userCredential.user.uid,
        referrer: formikRegisterStore.values.referrer,
        utm_id: formikRegisterStore.values.utm_id,
        projectId: formikRegisterStore.values.projectId,
        verificationUrl: formikRegisterStore.values.verificationUrl,
        device: isMobileOnly
          ? "mobile"
          : isTablet
            ? "tablet"
            : isDesktop
              ? "desktop"
              : "other",
        declarationOfConsent: formikRegisterStore.values.declarationOfConsent,
      };

      if (
        formikRegisterStore.values?.utm_id &&
        formikRegisterStore.values?.utm_id !== ""
      ) {
        newUserData.utm_id = formikRegisterStore.values?.utm_id;
      }

      if (
        formikRegisterStore.values?.mode &&
        formikRegisterStore.values?.mode !== ""
      ) {
        newUserData.mode = formikRegisterStore.values?.mode;
      }

      await setDoc(doc(db, "users", userCredential.user.uid), newUserData);

      await setDoc(
        doc(
          db,
          "users",
          userCredential.user.uid,
          "Private",
          userCredential.user.uid
        ),
        {
          email: formikRegisterStore.values.email,
          userId: userCredential.user.uid,
        }
      );
      const visitHistoryRef = collection(
        db,
        "users",
        userCredential.user.uid,
        "activityLogbook"
      );
      const now = new Date().getTime();
      const visitData = {
        userId: userCredential.user.uid,
        projectId: formikRegisterStore.values.projectId || null,
        timeStamp: now,
        createdAt: new Date().toISOString(),
        url: window.location.href,
        referrer: formikRegisterStore.values.referrer,
        utm_id: formikRegisterStore.values.utm_id,
        device: isMobileOnly
          ? "mobile"
          : isTablet
            ? "tablet"
            : isDesktop
              ? "desktop"
              : "other",
      };
      await addDoc(visitHistoryRef, visitData);
    } catch (error) {
      throw new Error(error, "Error in createUserInDatabase");
    }
  }
}
